import { forEachElement, getElementById } from "../util/Utils";

/**
 *
 */
export class UpdateReferencedAction implements EventListenerObject {
  /*                  */

  static on(elem: HTMLElement, listener = new UpdateReferencedAction()) {
    elem.addEventListener("input", listener, {
      passive: true,
    });
  }

  /*               */

  /*                 */

  handleEvent(event: Event) {
    const { target } = event;
    if (target instanceof HTMLInputElement) {
      UpdateReferencedAction.updateReferenced(target);
    }
  }

  static updateAllValues(target: HTMLInputElement) {
    const { name, value, checked } = target;
    forEachElement<HTMLInputElement>(`input[name="${name}"][value="${value}"]`, (input) => {
      input.checked = checked;
    });
  }

  static updateReferenced(target: HTMLInputElement) {
    const {
      checked,
      dataset: { tsRef },
    } = target;
    const ref = getElementById<HTMLInputElement>(tsRef);
    if (ref) {
      ref.checked = checked;
    }
  }
}
